import {
  Alert,
  AlertIcon,
  AlertDescription,
  Flex,
  CloseButton,
} from '@chakra-ui/react';
import React from 'react';

import { finleyAssert } from '@finley-technologies/common';

import { useReceivableReconciliationAlertContext } from './ReceivableReconciliationAlertContext';

export const ReceivableReconciliationAlert = () => {
  const {
    jobState,
    jobType,
    receivableCountForConfirmationJob,
    canRetryUpload,
    clearAlert,
    creditFacilityName,
  } = useReceivableReconciliationAlertContext();

  if (jobState === 'inProgress' && jobType) {
    return (
      <Alert status="warning">
        <AlertIcon />
        <AlertDescription>Receivable {jobType} in progress.</AlertDescription>
      </Alert>
    );
  }
  if (jobState === 'success' && jobType && receivableCountForConfirmationJob) {
    finleyAssert(
      (jobType === 'repurchase' && !creditFacilityName) ||
        (jobType === 'transfer' && creditFacilityName),
      'Invalid creditFacilityName for jobType for Receivable Reconciliation Alert',
    );

    const receivablesText = `${receivableCountForConfirmationJob} ${
      receivableCountForConfirmationJob === 1
        ? ' receivable has '
        : ' receivables have '
    }`;

    const actionText = `${
      jobType === 'repurchase'
        ? `repurchased and ${
            receivableCountForConfirmationJob === 1 ? 'is' : 'are'
          } now on the
            balance sheet.`
        : `transferred to ${creditFacilityName}.`
    }`;

    return (
      <Alert status="success" justifyContent="space-between">
        <Flex gap={1}>
          <AlertIcon />
          <AlertDescription>
            {receivablesText} been successfully {actionText}
            {canRetryUpload
              ? ` To try again, start a New Report for this date and use the file from the earlier version.`
              : ''}
          </AlertDescription>
        </Flex>
        <CloseButton
          alignSelf="flex-start"
          position="relative"
          right={-1}
          onClick={clearAlert}
        />
      </Alert>
    );
  }
  if (jobState === 'error' && jobType) {
    return (
      <Alert status="error" justifyContent="space-between">
        <Flex gap={1}>
          <AlertIcon />
          <AlertDescription>
            An unexpected error occurred during receivable {jobType}. Please
            contact Finley for support.
          </AlertDescription>
        </Flex>
        <CloseButton
          alignSelf="flex-start"
          position="relative"
          right={-1}
          onClick={clearAlert}
        />
      </Alert>
    );
  }
  return null;
};
